/**
 * Signalling server URL, fixed at build time from the `TERRITILE_SIGNALLING_URL`
 * env var (see farm.config.ts); players can't change it from the UI.
 */
export const SIGNALLING_URL = "wss://signal.territile.com";

/**
 * This build's id (see farm.config.ts), published as lobby metadata: players
 * on different builds can't start a match together.
 */
export const BUILD_ID = "20261015070003-aaf4a84";
